import { useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { ListItemButton, ListItemIcon, Typography } from "@mui/material";
import { Constants } from "../Constants";
import { theme } from "../styles/theme";
import CheckIcon from "@mui/icons-material/Check";
import i18next from "i18next";
import { StorageService } from "../services/StorageService";

export const LanguagesList: React.FC = () => {

  const storageService = new StorageService();
  const languages = Constants.language.languageItems;

  const defaultLanguage = storageService.get(Constants.storage.keys.selectedLanguage) || "en";
  const [selectedLanguage, setSelectedLanguage] = useState<string>(defaultLanguage);
  

  const handleSelect = (language: string) => () => {
    setSelectedLanguage(language);
    storageService.set(Constants.storage.keys.selectedLanguage, language)
    i18next.changeLanguage(language);
  };

  return (
    <List disablePadding>
      {languages.map((language, index) => {
        const isSelected = selectedLanguage === language.key;

        return (
          <ListItem
            key={language.key}
            disableGutters
            disablePadding
            sx={{
              margin: "4px 0",
              backgroundColor: theme.palette.common.white,
              color: theme.palette.text.secondary,
            }}
          >
            <ListItemButton
              onClick={handleSelect(language.key)}
              sx={{
                padding: "10px 12px",
              }}
              selected={isSelected}
              disableRipple
              data-parentid="language-list"
              data-id={`language-item-${language.key}`}
            >
              <ListItemText
                secondary={
                  <Typography variant="body2" fontWeight="inherit">
                    {language.value}
                  </Typography>
                }
              />
              {isSelected && (
                <ListItemIcon>
                  <CheckIcon color="primary" />
                </ListItemIcon>
              )}
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};
